import script from "./ClassRequests.vue?vue&type=script&setup=true&lang=js"
export * from "./ClassRequests.vue?vue&type=script&setup=true&lang=js"

import "./ClassRequests.vue?vue&type=style&index=0&id=b3a6e450&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3a6e450"]])

export default __exports__